var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNew = function SvgNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#E22F22"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.54 13.35-.6-1.05h-.05l.16 1.06V17h-1.4V9.95h1.07l2.89 3.73.57 1.02h.06l-.16-1.03V10h1.4v7.05H7.41l-2.87-3.7ZM9.779 10h4.51v1.3h-3.03v1.52h2.75v1.3h-2.75v1.58h3.08V17h-4.56v-7Zm7.644 3.85.14 1.24h.04l.16-1.26 1.33-3.83h.96l1.31 3.85.16 1.24h.05l.15-1.26.93-3.83h1.52l-2.1 7.05h-1l-1.36-3.81-.18-1.08h-.07l-.18 1.09-1.35 3.8h-1.05L14.793 10h1.62l1.01 3.85Z",
    fill: "#fff"
  })));
};
export default SvgNew;